import { useQuery } from "react-query";
import { Button, Col, Divider, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { DefinitionService } from "../../services/DefinitionService";
import { mdlHotelRoomTypeListRequest } from "../../models/service-models/hotel/HotelRoomTypeListRequest";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTrash } from "@fortawesome/free-solid-svg-icons";

export type HotelRoomTypeSelectProps = {
    onDeselect?: Function;
    hotelId?: string;
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    sendObject?: boolean;
    fnSelectAll?: Function;
    fnClearAll?: Function;
}


export const HotelRoomTypeSelect = (props: HotelRoomTypeSelectProps) => {
    const { t } = useTranslation();

    const {
        data,
        isLoading
    } = useQuery(
        ["getHotelRoomTypes", props.hotelId],
        () => {
            if (props.hotelId) {
                var request: mdlHotelRoomTypeListRequest = { pageSize: 0, hotelId: props.hotelId };
                return DefinitionService.HotelRoomTypeList(request);
            }

        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.hotelId
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    const handleSendObject = (option: any) => {
        const selectedOption = Array.isArray(option) ? option.map(opt => opt) : option;
        props.onChange!(selectedOption);
    }

    const handleSendObjectToDeselect = (option: any) => {
        const selectedOption = Array.isArray(option) ? option.map(opt => opt) : option;
        props.onDeselect!(selectedOption);
    }

    let cities = data?.body?.data;

    const handleSelectAll = () => {
        props.fnSelectAll && props.fnSelectAll(cities?.map((x: any) => x.roomTypeId))
    }
    const handleClearAll = () => {
        props.fnClearAll && props.fnClearAll();
    }
    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                size="middle"
                onFocus={onFocus}
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onDeselect={(value: string | string[], option: any) =>
                    props.sendObject ? handleSendObjectToDeselect(option) : props.onChange!(value)}
                onChange={(value: string | string[], option: any) =>
                    props.sendObject ? handleSendObject(option) : props.onChange!(value)}
                showSearch
                placeholder={t("common.chooseHotelRoomType")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={cities?.map((h: any) => Object.assign(h, {
                    label: h.name,
                    value: h.roomTypeId,
                    code: h.roomTypeId
                }))}
                dropdownRender={(menu) => (
                    <>
                        {
                            (props.fnSelectAll || props.fnClearAll) &&
                            <>
                                <Row gutter={16} className="mb-1 mt-1">
                                    {
                                        props.fnSelectAll &&
                                        <>
                                            <Col span={12}>
                                                <Button type="text" className="btn btn-sm btn-outline-primary w-100" onClick={() => handleSelectAll()}>
                                                    <FontAwesomeIcon icon={faCheck} />
                                                    {t('common.checkAll')}
                                                </Button>
                                            </Col>
                                        </>
                                    }
                                    {
                                        props.fnClearAll &&
                                        <>
                                            <Col span={12}>
                                                <Button type="text" className="btn  btn-sm btn-outline-secondary w-100" onClick={() => handleClearAll()}>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                    {t('common.clear')}
                                                </Button>
                                            </Col>
                                        </>
                                    }
                                </Row>
                                <Divider style={{ margin: '8px 0' }} />
                            </>
                        }
                        {menu}
                    </>
                )}
            />
        </>
    )
}